// **********************************************************
// Gallery Slider
// **********************************************************

const gallerySlider = document.querySelectorAll('[data-slider="gallery-slider"]');

const gallerySliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 0,
  watchOverflow: true,
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
};

const initGallerySlider = () => {
  gallerySlider.forEach((el) => {
    const parentEle = el.closest('[data-slider-parent]');

    if (windowWidth() > 767) {
      const sliderEle = new Swiper(el, gallerySliderOptions);
      swiperLockClass(el, sliderEle);
    } else {
      enableScrollbarSync(parentEle);
    }
  });
};

initGallerySlider();

setupResponsiveSliders({
  sliderElements: gallerySlider,
  breakpoint: 767,
  initSlider: initGallerySlider,
  mobileFallback: enableScrollbarSync,
  parentSelector: '[data-slider-parent]',
});
